require('./externalTransferValuesStep2.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const classNames = require('classnames');
const { withRouter } = require('react-router-dom');

// @commons
const { InputSafe } = require('commonsComponents/inputSafe');
const { OKIconButton } = require('commonsComponents/OKIconButton');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');

// @ components
const OKMultipleSelect = require('components/commons/OKMultipleSelect/OKMultipleSelect');
const BrokerProductAdvancedSearch = require('components/broker/brokerProductAdvancedSearch/brokerProductAdvancedSearch');

// @actions
const BrokerProductFiltersSearchActions = require('actions/brokerProductFiltersSearch');
const BrokerProductAdvancedSearchActions = require('actions/brokerProductAdvancedSearch');
const BrokerAdvancedSearchTaggingActions = require('actions/brokerAdvancedSearchTagging');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { capitalize } = require('utilities/stringHelper');

// @constants
const {
    TYPE_STOCKS,
    TYPE_WARRANTS,
    TYPE_ETFS,
    TYPE_GENERAL_PRODUCT,
    BROKER_PRODUCT_ADVANCED_SEARCH_MARKET,
    BROKER_PRODUCT_ADVANCED_SEARCH_TERM,
    BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES,
    NON_NUMERIC_REGEXP,
    BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT,
    BROKER_TRANSFER_EXTERNAL_VALUES
} = require('constants/index');
const limitedProducts = [TYPE_STOCKS, TYPE_ETFS, TYPE_WARRANTS];
const formattedLimitedProduct = limitedProducts.map(value => value.toUpperCase());
const { MAXIMUM_PRODUCT_LIMIT } = require('../constants');

class ExternalTransferValuesStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editId: -1,
            searchClicked: false
        }
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleTermChange = this.handleTermChange.bind(this);
        this.handleMarketChange = this.handleMarketChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleProductTypeChange = this.handleProductTypeChange.bind(this);
        this.onHandleClickSelectButton = this.onHandleClickSelectButton.bind(this);
        this.handleChangeNoOfProduct = this.handleChangeNoOfProduct.bind(this);
        this.searchSpecificProduct = this.searchSpecificProduct.bind(this);
        this.searchWithPage = this.searchWithPage.bind(this);
        this.retryAdvancedSearch = this.retryAdvancedSearch.bind(this);
        this.retryAdvancedSearchSpecificProduct = this.retryAdvancedSearchSpecificProduct.bind(this);
    }

    componentDidMount() {
        const {
            productType,
            applyLimitedFilters,
            setSpecificProduct,
            immBrokerProductFiltersSearch,
            getFilters
        } = this.props;
        const isFetchingFilters = immBrokerProductFiltersSearch.get('isFetchingFilters');
        const successFilters = immBrokerProductFiltersSearch.get('successFilters');
        applyLimitedFilters(BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES, formattedLimitedProduct);

        if (!!productType) {
            setSpecificProduct(productType.toUpperCase());
        }
        if(!isFetchingFilters && !successFilters) {
            getFilters();
        }
    }

    componentDidUpdate(nextProps) {
        const { productType, applyLimitedFilters } = this.props;
        if(nextProps.productType !== productType) {
            applyLimitedFilters(BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES, formattedLimitedProduct);
        }
    }

    handleChangeNoOfProduct(value, index) {
        const { setNoOfProducts } = this.props;
        const formattedValue = value.replace(NON_NUMERIC_REGEXP, '');
        let expectedValue;
        if (formattedValue === "") {
            expectedValue = "0";
        } else if (formattedValue.length > 1 && formattedValue[0] === "0") {
            expectedValue = formattedValue[1];
        } else {
            expectedValue = formattedValue;
        }
        setNoOfProducts(expectedValue, index);
    }

    handleProductTypeChange(productTypes) {
        const { handleFieldMultipleChange, history, productType } = this.props;

        !!productType && history.push(BROKER_TRANSFER_EXTERNAL_VALUES);
        handleFieldMultipleChange(BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES, productTypes);
    }

    handleMarketChange(market) {
        this.props.handleFieldChange(BROKER_PRODUCT_ADVANCED_SEARCH_MARKET, market);
    }

    handleTermChange(event) {
        this.props.handleFieldChange(BROKER_PRODUCT_ADVANCED_SEARCH_TERM, event.target.value);
    }

    searchSpecificProduct(productType) {
        this.props.searchSpecificProduct(productType, BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT);
    }

    searchWithPage(pageNumber) {
        this.props.searchWithPage(pageNumber, BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT);
    }

    retryAdvancedSearch() {
        this.props.retryAdvancedSearch(limitedProducts);
    }

    retryAdvancedSearchSpecificProduct() {
        this.props.retryAdvancedSearchSpecificProduct(BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT);
    }

    handleSearch() {
        const { productType, advancedSearchProducts, immBrokerProductFiltersSearch, searchSpecificProduct } = this.props;
        const isOnlyOneProductSelected = immBrokerProductFiltersSearch.get('isOnlyOneProductSelected');
        const limitedProducts = !!productType ? [productType] : [TYPE_STOCKS, TYPE_ETFS, TYPE_WARRANTS];
        const formattedLimitedProduct = limitedProducts.map(value => value.toUpperCase());
        if (isOnlyOneProductSelected) {
            const productTypeObject = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES, 0]);
            searchSpecificProduct(productTypeObject.value, BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT);
        } else {
            advancedSearchProducts(BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT, formattedLimitedProduct);
        }
        this.setState({
            searchClicked: true
        });
    }

    handleEdit(editIndex) {
        const { immStep, deleteProduct } = this.props;
        const productsArray = immStep.get('selectedProductsArray');
        const lastProductIndex = productsArray.size - 1;
        const isFreshlyAdded = productsArray.getIn([lastProductIndex, 'product']) === null;
        if (isFreshlyAdded && editIndex !== this.state.editId) {
            deleteProduct(lastProductIndex);
        }
        this.clearFilters();
        this.setState({
            editId: editIndex
        });
    }

    clearFilters() {
        const { clearResults, getFilters, applyLimitedFilters, productType } = this.props;
        const formattedLimitedProduct = limitedProducts.map(value => value.toUpperCase());
        !productType && clearResults();
        applyLimitedFilters(BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES, formattedLimitedProduct);
        getFilters();
        this.setState({
            searchClicked: false
        });
    }

    handleCancel() {
        this.props.resetDuplicateError(this.state.editId);
        this.clearFilters();
        this.setState({
            editId: -1
        });
    }

    handleDelete(productIndex) {
        const { deleteProduct, undoDeletion } = this.props;
        deleteProduct(productIndex, undoDeletion);
        this.handleCancel();
    }

    onHandleClickSelectButton(product) {
        const { setBrokerSearchField } = this.props;
        const currentProductIndex = this.state.editId;
        setBrokerSearchField(product, currentProductIndex);
    }

    createSearchFields() {
        const {
            immBrokerProductFiltersSearch,
            immBrokerProductAdvancedSearch,
            advancedSearchProducts,
            retryCombosFilters,
            updateFiltersCombosConfiguration,
            retryAdvancedSearchSpecificProduct,
            searchSpecificProductTracking
        } = this.props;
        const productTypes = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]).toJS();

        const resultList = this.state.searchClicked && (
            <BrokerProductAdvancedSearch
                immBrokerProductAdvancedSearch={immBrokerProductAdvancedSearch}
                immBrokerProductFiltersSearch={immBrokerProductFiltersSearch}
                advancedSearchProducts={advancedSearchProducts}
                searchSpecificProduct={this.searchSpecificProduct}
                searchSpecificProductTracking={searchSpecificProductTracking}
                searchWithPage={this.searchWithPage}
                retryCombosFilters={retryCombosFilters}
                updateFiltersCombosConfiguration={updateFiltersCombosConfiguration}
                retryAdvancedSearch={this.retryAdvancedSearch}
                retryAdvancedSearchSpecificProduct={retryAdvancedSearchSpecificProduct}
                stopViewMoreRedirections={true}
                showSelectButton={true}
                handleClickSelectButton={this.onHandleClickSelectButton}
                hideCommercialAds={true}
            />
        );

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-xs-4">
                        <FormattedText
                            className="external-transfer-values-step2__product-label"
                            value="externalTransferValues-externalTransferValues_productSearchLabel"
                        />
                        <InputSafe
                            id="brokerAdvancedSearchTerm"
                            autoComplete="off"
                            type="text"
                            value={immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_TERM])}
                            onChange={this.handleTermChange}
                        />
                    </div>
                    <div className="col-xs-3">
                        <OKSelect
                            label={formatText('broker-advancedSearchMarketLabel')}
                            options={immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_MARKET]).toJS()}
                            onChange={this.handleMarketChange}
                            value={immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_MARKET]).value}
                            placeholder={formatText('broker-allOptionsM')}
                            searchable={false}
                        />
                    </div>
                    <div className="col-xs-3">
                        <OKMultipleSelect
                            id="products"
                            label={formatText('broker-advancedSearchProductLabel')}
                            options={immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]).toJS()}
                            onChange={this.handleProductTypeChange}
                            value={productTypes}
                            placeholder={formatText('broker-allOptionsM')}
                            overflowed={true}
                        />
                    </div>
                    <div className="col-xs-2 external-transfer-values-step2__search-button">
                        <OKButton
                            onClick={this.handleSearch}
                            modifier="primary"
                            loading={false}
                        >
                            <FormattedText value="broker-advancedSearchSubmit" />
                        </OKButton>
                    </div>
                </div>
                {resultList}
            </React.Fragment>
        );
    }

    createProductSelectRow(product, productIndex, productsLength) {
        const { immStep } = this.props;
        const noProductLabel = formatText('externalTransferValues-externalTransferValues_productEmptyPlaceholder');
        const productName = product.getIn(['product', 'name']);
        const isEditable = productIndex === this.state.editId;
        const isLastAddedELementWithEmpty = productIndex === productsLength - 1 && !productName;
        const searchFields = (isEditable || isLastAddedELementWithEmpty) && (
            <div className="external-transfer-values-step2__search-containert">
                {this.createSearchFields()}
            </div>
        );
        const productValue = productName || noProductLabel;
        const withProduct = !!product && !isLastAddedELementWithEmpty;
        let firstActionButton, deleteButton;
        if (withProduct) {
            if (isEditable) {
                firstActionButton = (
                    <OKIconButton
                        size="small"
                        icon="icon-cerrar"
                        id="cancel-button"
                        onClick={this.handleCancel}
                    />
                );
            } else {
                firstActionButton = (
                    <OKIconButton
                        size="small"
                        icon="icon-editar"
                        id="edit-button"
                        onClick={() => {
                            this.handleEdit(productIndex);
                        }}
                    />
                );
            }
            deleteButton = (
                <OKIconButton
                    icon="icon-eliminar"
                    id="delete-button"
                    size="small"
                    onClick={() => {
                        this.handleDelete(productIndex);
                    }}
                />
            );
        }

        const productLabel = (isEditable || isLastAddedELementWithEmpty) ? "productEmptyLabel" : "productSelectedLabel";
        const noOfProducts = product.get('noOfProducts');
        const noOfProductsIsDirty = immStep.get('noOfProductsIsDirty');
        const duplicateProductError = product.get('duplicateProductError');
        const productFieldClasses = classNames('external-transfer-values-step2__product-field', {
            'external-transfer-values-step2__product-field--error': duplicateProductError
        });
        const productFieldErrorMessage = duplicateProductError && (
            <FormattedText
                className="external-transfer-values-step2__product-field-error-message"
                value="externalTransferValues-externalTransferValues_duplicateProductError"
            />
        );

        return (
            <div className="external-transfer-values-step2__input-section">
                <div className="row">
                    <div className="col-xs-5">
                        <FormattedText
                            className="external-transfer-values-step2__product-label"
                            value={`externalTransferValues-externalTransferValues_${productLabel}`}
                        />
                        <div className="external-transfer-values-step2__product-field-container">
                            <div>
                                <div className={productFieldClasses}>
                                    <span>{productValue}</span>
                                </div>
                                {productFieldErrorMessage}
                            </div>
                            {firstActionButton}
                        </div>
                    </div>
                    <div className="col-xs-7">
                        <div className="external-transfer-values-step2__product-count-container">
                            <div className="external-transfer-values-step2__product-count">
                                <InputSafe
                                    disabled={!withProduct}
                                    label={formatText('externalTransferValues-externalTransferValues_noOfProducts')}
                                    type="text"
                                    value={noOfProducts}
                                    errorState={noOfProducts <= 0 && noOfProductsIsDirty && withProduct}
                                    errorMessage={formatText('externalTransferValues-externalTransferValues_numberOfValuesErrorMessage')}
                                    onChange={(event) => {
                                        this.handleChangeNoOfProduct(event.target.value, productIndex);
                                    }}
                                />
                            </div>
                            <div className="external-transfer-values-step2__delete-button-wrapper">
                                {deleteButton}
                            </div>
                        </div>
                    </div>
                </div>
                {searchFields}
            </div>
        );
    }

    createAddProductRowLink() {
        const { immStep, addAnotherProduct } = this.props;
        const productsArray = immStep.get('selectedProductsArray');
        const productsArrayLength = productsArray.size;
        const isAdded = productsArray.getIn([productsArrayLength - 1, 'product']) === null;
        const linkDisabled = this.state.editId !== -1 || isAdded || productsArrayLength === MAXIMUM_PRODUCT_LIMIT;
        const extraClasses = classNames('external-transfer-values-step2__add-product', {
            'external-transfer-values-step2__add-product--disabled': linkDisabled
        });

        return (
            <OKLink
                extraClass={extraClasses}
                id="btnAccountIntervenersCancel"
                icon="agregar"
                modifier="inherit-styles"
                onClick={() => {
                    !linkDisabled && addAnotherProduct();
                }}
            >
                <FormattedText value="externalTransferValues-externalTransferValues_addProductLabel" />
            </OKLink>
        );
    }

    render() {
        const {
            productType,
            immStep
        } = this.props;
        let productName = TYPE_GENERAL_PRODUCT;
        if (!!productType) {
            productName = productType;
        }
        const productLabel = formatText(`externalTransferValues-externalTransferValues_${productName}`);
        const formattedProductLabel = capitalize(productLabel);
        const products = immStep.get('selectedProductsArray');
        const lastProduct = products.getIn([products.size - 1, 'product']);
        const productsLength = products.size;
        const noOfProductsAdded = !!lastProduct ? productsLength : productsLength - 1;
        const productRows =  products.map((product, index) => this.createProductSelectRow(product, index, productsLength));
        const addProductRowLink = this.createAddProductRowLink();

        return (
            <div className="external-transfer-values-step2">
                <h2 className="external-transfer-values-step2__title">
                    <FormattedText
                        value="externalTransferValues-externalTransferValues_step2Title"
                        injectedStrings={[formattedProductLabel]}
                    />
                </h2>
                <div className="external-transfer-values-step2__main-section">
                    <h3 className="external-transfer-values-step2__sub-title">
                        <FormattedText value="externalTransferValues-externalTransferValues_step2SubTitle"/>
                        <FormattedText
                            className="external-transfer-values-step2__sub-title-count"
                            value="externalTransferValues-externalTransferValues_productCountLabel"
                            injectedStrings={[noOfProductsAdded, MAXIMUM_PRODUCT_LIMIT]}
                        />
                    </h3>
                    {productRows}
                    {addProductRowLink}
                </div>
            </div>
        );
    }
}

ExternalTransferValuesStep2.propTypes = {
    applyLimitedFilters: PropTypes.func.isRequired,
    addAnotherProduct: PropTypes.func.isRequired,
    deleteProduct: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immStep: PropTypes.object.isRequired,
    immBrokerProductFiltersSearch: PropTypes.object.isRequired,
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    productType: PropTypes.string,
    getFilters: PropTypes.func,
    retryCombosFilters: PropTypes.func,
    updateFiltersCombosConfiguration: PropTypes.func,
    handleFieldChange: PropTypes.func,
    advancedSearchProducts: PropTypes.func,
    searchWithPage: PropTypes.func,
    searchSpecificProduct: PropTypes.func,
    setSpecificProduct: PropTypes.func,
    searchSpecificProductTracking: PropTypes.func,
    retryAdvancedSearch: PropTypes.func,
    resetDuplicateError: PropTypes.func,
    retryAdvancedSearchSpecificProduct: PropTypes.func,
    handleFieldMultipleChange: PropTypes.func,
    clearResults: PropTypes.func,
    setBrokerSearchField: PropTypes.func,
    setNoOfProducts: PropTypes.func,
    undoDeletion: PropTypes.func.isRequired,
};

ExternalTransferValuesStep2.defaultProps = {
    productType: ''
};

module.exports = connect((state) => ({
    immBrokerProductFiltersSearch: state.brokerProductFiltersSearch,
    immBrokerProductAdvancedSearch: state.brokerProductAdvancedSearch,
}), {
    applyLimitedFilters: BrokerProductFiltersSearchActions.applyLimitedFilters,
    getFilters: BrokerProductFiltersSearchActions.getFilters,
    handleFieldChange: BrokerProductFiltersSearchActions.handleFieldChange,
    handleFieldMultipleChange: BrokerProductFiltersSearchActions.handleFieldMultipleChange,
    clearResults: BrokerProductFiltersSearchActions.clearResults,
    retryCombosFilters: BrokerProductFiltersSearchActions.retryCombosFilters,
    updateFiltersCombosConfiguration: BrokerProductFiltersSearchActions.updateFiltersCombosConfiguration,
    advancedSearchProducts: BrokerProductAdvancedSearchActions.advancedSearchProducts,
    searchWithPage: BrokerProductAdvancedSearchActions.searchWithPage,
    searchSpecificProduct: BrokerProductAdvancedSearchActions.searchSpecificProduct,
    setSpecificProduct: BrokerProductAdvancedSearchActions.setSpecificProduct,
    searchSpecificProductTracking: BrokerAdvancedSearchTaggingActions.searchSpecificProductTracking,
    retryAdvancedSearch: BrokerProductAdvancedSearchActions.retryAdvancedSearch,
    retryAdvancedSearchSpecificProduct: BrokerProductAdvancedSearchActions.retryAdvancedSearchSpecificProduct,
})(withRouter(ExternalTransferValuesStep2));
